export default __webpack_public_path__ + "static/Graphik-Bold-Web-92bbada92e4425749709f2691d9362f9.svg";